import { Field, FieldAttributes, FieldProps } from 'formik';
import { forwardRef, useMemo } from 'react';
import Input, { InputProps } from './Input';

interface FormikInputProps extends InputProps {
    fieldProps?: FieldAttributes<any>;
}

const FormikInput = forwardRef<HTMLInputElement, FormikInputProps>((props, ref) => {
    const { name, id, fieldProps, invalid, ...rest } = props;

    const idOrName = useMemo(() => {
        return id || name;
    }, [id, name]);

    return (
        <Field name={name} {...fieldProps}>
            {({ field, meta }: FieldProps) => (
                <Input
                    {...rest}
                    {...field}
                    ref={ref}
                    id={idOrName}
                    name={name}
                    invalid={(meta.touched && Boolean(meta.error)) || invalid}
                />
            )}
        </Field>
    );
});

export default FormikInput;
